<template>
  <div class="collection-Records">
    <el-form :inline="true" label-width="90px">
      <el-row :gutter="26">
        <el-col
          :span="22"
          class="key-input"
          style="border-right: 1px #e5e6eb solid"
        >
          <el-row :span="24">
            <el-col :span="12">
              <el-form-item label="搜索">
                <el-input
                  clearable
                  v-model="searchInfo.keyword"
                  placeholder="请输入会员编号、用户名称、编号、手机号、邮箱"
                  size="mini"
                  suffix-icon="el-icon-search"
                  width="100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会员内容" style="width: 100%">
                <el-select
                  clearable
                  v-model="searchInfo.idcVipId"
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="item in vipSelectList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="状态" style="width: 100%">
                <el-select
                  clearable
                  v-model="searchInfo.status"
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="到期时间">
                <el-date-picker
                  clearable
                  v-model="dateNow"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  size="mini"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2" class="right-button">
          <el-button icon="el-icon-search" @click="search">查询</el-button>
          <el-button
            class="reset-btn"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <div style="border-bottom: 1px #e5e6eb solid; margin: 20px 0"></div>
    <el-table
      v-loading="loading"
      empty-text="暂无数据"
      :data="tableData"
      style="width: 100%"
      size="small"
    >
      <el-table-column align="center" label="用户" width="150" prop="un">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="auto">
            <div
              slot="reference"
              @click="toUserDetail(scope)"
              class="submitted"
            >
              {{ scope.row.un || "--" }}
            </div>
            <div
              style="
                display: flex;
                text-overflow: ellipsis;
                white-space: pre-line;
                cursor: pointer;
                color: #165dff;
                justify-content: center;
              "
            >
              <span @click="toUserDetail(scope)">
                {{ scope.row.un || "--" }}
              </span>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="会员内容"
        prop="idcVipId"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ vipAll[scope.row.idcVipId] || "--" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="手机号" prop="mb" min-width="120">
      </el-table-column>
      <el-table-column align="center" label="邮箱" prop="email" min-width="125">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="auto">
            <div
              slot="reference"
              class="submitted"
              style="cursor: default; color: #606266"
            >
              {{ scope.row.email || "--" }}
            </div>
            <div
              style="
                display: flex;
                text-overflow: ellipsis;
                white-space: pre-line;
                justify-content: center;
              "
            >
              {{ scope.row.email || "--" }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="会员内容" prop="regTime">
        <template slot-scope="scope">
          {{ scope.row.effectiveDays||"" }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column align="center" label="激活时间" prop="customerName">
        <template slot-scope="scope">
          {{ scope.row.effectiveDays || "--" }}
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        label="到期时间"
        prop="expires"
        width="150"
      >
        <template slot-scope="scope">
          {{ scope.row.expires || "--" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <div class="status-content">
            <div
              class="status-color"
              :style="getStatusColor(scope.row.status)"
            ></div>
            <span> {{ tableStatusText[scope.row.status] }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" prop="createdAt">
        <template slot-scope="scope">
          <div class="">
            <div @click="toDetail(scope.row.id)" class="view-detail">
              查看详情
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @current-change="changepagefn"
        :page-size="size"
        :current-page="page"
        @size-change="handleSizeChange"
        :page-sizes="[5, 10, 20, 50, 100]"
        layout="->,sizes,total,prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      class="vip-detail-space"
      title="会员详情"
      :visible.sync="showDetail"
      width="65%"
    >
      <el-table :data="detailData">
        <el-table-column property="content" label="会员">
          <template slot-scope="scope">
            {{ vipAll[scope.row.idcVipId] || "--" }}
          </template>
        </el-table-column>
        <el-table-column property="content" label="会员内容"></el-table-column>
        <el-table-column
          property="activeTime"
          label="生效时间"
          width="150"
        ></el-table-column>
        <el-table-column
          property="expires"
          label="截止时间"
          width="150"
        ></el-table-column>
        <el-table-column property="source" label="开通方式" width="100">
          <template slot-scope="scope">
            {{ sourceMap[scope.row.source] }}
          </template>
        </el-table-column>
        <el-table-column property="status" label="状态" width="80">
          <template slot-scope="scope">
            {{ statusMap[scope.row.status] }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @current-change="detailTableChangepage"
          :page-size="detailSize"
          :current-page="detailPage"
          layout="->,total,prev, pager, next"
          :total="detailTotal"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { env } from "@/utils/util.js";
export default {
  props: {
    promotionId: "",
  },
  data() {
    return {
      showDetail: false,
      detailData: [],
      tableData: [],
      searchInfo: {
        keyword: "",
        expires: "",
        idcVipId: "",
        status: "",
      },
      sourceMap: {
        1: "绑定赠送",
        2: "订单支付",
        3: "兑换码",
        4: "订阅",
        5: "体验",
        6: "系统",
      },
      statusMap: {
        "-1": "已退款(系统标识)",
        1: "未生效",
        2: "已生效",
        3: "已作废",
        4: "已过期",
      },
      tableStatusText: {
        1: "激活中",
        2: "已过期",
      },
      size: 10,
      total: 0,
      page: 1,
      detailPage: 1,
      detailSize: 10,
      detailTotal: 0,
      dateNow: "",
      loading: false,
      statusList: [
        {
          key: 0,
          value: "全部",
        },
        {
          key: 1,
          value: "激活中",
        },
        {
          key: 2,
          value: "已过期",
        },
      ],
      vipSelectList: [],
      curId: "",
      curUserId: "",
      downloadBaseURL: "",
      vipAll: {},
    };
  },
  created() {
    this.getDataList();
    const vipAll = localStorage.getItem("VIP_ALL");
    if (vipAll) {
      this.vipAll = JSON.parse(vipAll);
      // console.log("vipAll", this.vipAll);
      for (const key in this.vipAll) {
        if (this.vipAll.hasOwnProperty(key)) {
          this.vipSelectList.push({
            key: key,
            value: this.vipAll[key],
          });
        }
      }
    }
  },
  mounted() {
    const url = env();
    this.downloadBaseURL = url.downloadUrl;
  },
  methods: {
    getCurUserVip() {
      this.$get(`/user/vip/list`, {
        uid: this.curUserId,
        page: this.detailPage,
        size: this.detailSize,
      }).then((res) => {
        if (res.data.code === 1000) {
          this.detailData = res.data?.data?.list || [];
          this.detailTotal = res.data?.data?.count || 0;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toDetail(id) {
      this.showDetail = true;
      if (this.curUserId != id) {
        this.detailPage = 1;
      }
      this.curUserId = id;
      this.getCurUserVip();
    },
    // 查看用户详情
    toUserDetail(scope) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: scope.row.id,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    // 查看设备详情
    goDevDetail(id) {
      if (this.$jumpPerm("device_detail")) {
        this.mskflag = false;
        this.$router.push({
          path: "/devDetail",
          query: {
            id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    getDataList() {
      let regTime = "";
      if (this.dateNow)
        regTime =
          `${this.dateNow[0]} 00:00:00` + "~" + `${this.dateNow[1]} 23:59:59`;

      this.$get("/vip/users", {
        page: this.page,
        size: this.size,
        ...this.searchInfo,
      }).then((res) => {
        // console.log("res", res);
        if (res.data?.code === 1000) {
          this.tableData = res.data?.data?.list;
          this.total = res.data?.data?.count;
        }
      });
    },
    getStatusColor(value) {
      switch (value) {
        case 1:
          return { backgroundColor: "#00B42A" };
        case 2:
          return { backgroundColor: "#F53F3F" };
        default:
          return { backgroundColor: "#165DFF" };
      }
    },
    search() {
      this.page = 1;
      this.getDataList();
    },
    handleDateChange(dates) {
      if (dates && dates.length) {
        const regTime = `${dates[0]} 00:00:00` + "~" + `${dates[1]} 23:59:59`;
        this.searchInfo.expires = regTime;
      } else {
        this.searchInfo.expires = "";
      }
    },
    reset() {
      this.dateNow = "";
      this.searchInfo = {
        keyword: "",
        expires: "",
        idcVipId: "",
        status: "",
      };
      this.getDataList();
    },
    changepagefn(index) {
      this.page = index;
      this.getDataList(this.searchInfo);
    },
    detailTableChangepage(index) {
      this.detailPage = index;
      this.toDetail(this.curUserId);
    },
    handleSizeChange(val) {
      this.size = val;
      this.getDataList(this.searchInfo);
    },
  },
};
</script>

<style lang="less" scoped>
.collection-Records {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  // min-height: 100%;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}
.submitted {
  color: #165dff;
  cursor: pointer;
  width: 120px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 超出显示省略号 */
}
.el-popover {
  width: auto !important;
}
.right-button {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  .el-button {
    width: 82px;
    height: 28px;
    background-color: #165dff;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-top: 5px;
  }
  .reset-btn {
    color: #4e5969;
    background-color: #f2f3f5;
    margin-left: 0 !important;
    margin-top: 13px;
  }
}
::v-deep .key-input .el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .key-input1 {
  width: 100%;
}

::v-deep .key-input .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-form-item {
  display: flex !important;
}
::v-deep .el-select {
  margin-right: 10px;
}
.status-content {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.status-color {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  // background-color: #ff7d00;
}
.audit-opinion-desc {
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}
.audit-opinion {
  display: block !important;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0px;
}
::v-deep .el-dialog__body {
  padding: 34px 20px 0px;
}
::v-deep .el-dialog__footer {
  text-align: right;
}
.dialog-footer {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.dialog-btn {
  display: flex;
  width: 60px;
  height: 32px;
  background: #f2f3f5;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  cursor: pointer;
}
.confirm-btn {
  background-color: #165dff;
  color: #ffffff;
  margin-left: 8px;
}
.pagination {
  margin-top: 15px;
}
.view-detail {
  color: #165dff;
  cursor: pointer;
  width: 100%;
  text-align: center;
}
.vip-detail-space {
  ::v-deep .el-dialog__body {
    padding: 10px 20px 20px;
  }
}
</style>
